<template>
<v-container style="min-height: 100%; min-width: 100%;padding-top:2px;">
    <v-row align="start" width="100%">
        <NavBar test="Home"></NavBar>
    </v-row>
    <v-row style="height: 100vh;">
        <v-col class="pa-1" cols="3" style="height: 100vh;">
            <v-card style="height: 100vh;">
                <v-navigation-drawer style="height: 100vh;" permanent width="100%">
                    <v-list>
                        <v-list-item link>
                            <v-list-item-content>
                                <v-list-item-title class="title">{{name}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list rounded>
                        <v-list-item-group v-model="item" color="primary">
                            <v-list-item @click="goto(0)">
                                <v-list-item-icon>
                                    <v-icon >mdi-view-dashboard</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title >Dashboard</v-list-item-title>
                            </v-list-item>
                            <v-list-group no-action :value="false">
                                <template v-slot:activator>
                                    <v-icon>mdi-calendar</v-icon>
                                    <v-list-item-content style="padding-left:10%">
                                        <v-list-item-title >Inventory</v-list-item-title>
                                    </v-list-item-content>
                                </template>
                                <v-list-item @click="goto(11)" style="height:40px">
                                  <v-list-item-icon>
                                    <v-icon>mdi-calendar</v-icon>
                                  </v-list-item-icon>
                                      <v-list-item-title>Items</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="goto(14)" style="height:40px">
                                    <v-list-item-icon>
                                        <v-icon>add</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>Receive Inventory</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="goto(12)" style="height:40px">
                                    <v-list-item-icon>
                                        <v-icon>compare_arrows</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>Move Inventory</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="goto(13)" style="height:40px">
                                    <v-list-item-icon>
                                        <v-icon>add</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>Adjust Inventory</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="goto(15)" style="height:40px">
                                    <v-list-item-icon>
                                        <v-icon>history</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>Inventory History</v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                            <v-list-item @click="goto(2)" >
                                <v-list-item-icon>
                                    <v-icon>mdi-key</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Keys</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="goto(3)">
                                <v-list-item-icon>
                                    <v-icon>directions_car</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Vehicles</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-navigation-drawer>
            </v-card>
        </v-col>
        <v-col class="pa-1" cols="9" style="height: 100vh;">
            <v-card style="height: 100vh; overflow-y: auto; overflow-x: hidden">
                <router-view></router-view>
            </v-card>
        </v-col>
    </v-row>
</v-container>

</template>

<script>

import NavBar from '../NavBar.vue'

export default {
    components: {
        NavBar
    },
    created() {
        this.name = this.$store.state.token.name;
    },
    data: () => ({
        selected: '',
        isLoading: false,
        name: null,
        item:null
    }),
    methods: {
        inventory() {
                if (this.selected.localeCompare('Inventory') == 0)
                    this.selected = '';
                else
                    this.selected = 'Inventory';
            },
            keys() {
                if (this.selected.localeCompare('Keys') == 0)
                    this.selected = '';
                else
                    this.selected = 'Keys';
            },
            vehicles() {
                if (this.selected.localeCompare('Vehicles') == 0)
                    this.selected = '';
                else
                    this.selected = 'Vehicles';
            },
            goto(index) {
                switch (index) {
                    case 0:
                        this.$router.push('/inventory/dashboard');
                        break;
                    case 11:
                        this.$router.push('/inventory/items/find')
                        break;
                    case 12:
                        this.$router.push('/inventory/items/move')
                        break;
                    case 13:
                        this.$router.push('/inventory/items/adjust')
                        break;
                    case 14:
                        this.$router.push('/inventory/items/receive')
                        break;
                    case 15:
                        this.$router.push('/inventory/items/history')
                        break;
                    case 2:
                        this.$router.push('/inventory/keys');
                        break;
                    case 3:
                        this.$router.push('/inventory/vehicles');
                        break;
                }
            },
            shouldShowInventoryRelated() {
                return this.$store.state.isManager || this.$store.state.isAdmin;
            },


    }
}

</script>
